export const CONTACT_US_ACTION = 'CONTACT_US_ACTION';
export const CONTACT_US_SUCCESS_ACTION = 'CONTACT_US_SUCCESS_ACTION';
export const CONTACT_US_FAILURE_ACTION = 'CONTACT_US_FAILURE_ACTION';
